import { Button } from "@/components/ui/button";
import Section from "@/components/Section";
import ihmBusinessSchoolLogo from "@/assets/ihm-business-school-logo.png";

const AIForLeaders = () => {
  return (
    <Section
      eyebrow="AI-skilling"
      title={<>AI for <span className="text-gradient-brand">Leaders</span></>}
      description="Practical AI knowledge for executives, in collaboration with IHM Business School."
    >
      <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div className="space-y-6">
          <p className="text-muted-foreground text-lg leading-relaxed">
            Do you want to understand how AI transforms work processes and leadership requirements? Secure your practical AI knowledge and broaden your understanding of AI technology with the course AI for Leaders. This course, developed by us at the AI-Labbet in collaboration with IHM Business School, meets the increasing demand for strategic competence and equips you with the skills to effectively lead your organization in today's quickly evolving technological landscape. Sign up now for a unique opportunity to integrate AI into your leadership, ensuring both efficiency and competitiveness.
          </p>

          <a href="https://www.ihm.se/utbildningar/management/ai-for-ledare/" target="_blank" rel="noopener noreferrer">
            <Button variant="secondary" size="lg" className="mt-2">
              Read more →
            </Button>
          </a>
        </div>

        <div className="flex items-center justify-center">
          <div className="relative rounded-2xl border border-border/60 bg-card/60 backdrop-blur-sm p-10 w-full max-w-md">
            <img
              src={ihmBusinessSchoolLogo}
              alt="IHM Business School"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default AIForLeaders;
